import { DataSourceMode, LookupModelSearchEvent, LookupModelSelectionEvent, TableRow, TableRowDisplayEvent, Textbox, ValidationResult } from "@mcleod/components";
import { AutogenLayoutEdiApiUsers } from "./autogen/AutogenLayoutEdiApiUsers";
import { ModelRow } from "@mcleod/core/src/ModelRow";

export class EdiApiUsers extends AutogenLayoutEdiApiUsers {
    private _transactionType: string;
    private _profileId: string;

    onLoad() {
        this.tableEdiApiUsers.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow: TableRow = event.getTableRow();
            const textboxUserId = tableRow.findComponentById("textboxUserId") as Textbox;
            if (textboxUserId) {
                textboxUserId.addlValidationCallback = (value: string, mode: DataSourceMode) => {
                    if (mode === DataSourceMode.SEARCH) {
                        return null;
                    }
                    const id = tableRow.data.get("user_id");
                    const result: ValidationResult = {
                        component: textboxUserId,
                        isValid: true
                    }
                    const isDuplicate = this.tableEdiApiUsers.rows.some(existingRow => {
                        if (existingRow === tableRow) {
                            // Skip checking against itself
                            return false;
                        }
                        return id === existingRow.data.get("user_id");
                    });
                    if (isDuplicate) {
                        result.isValid = false;
                        result.validationMessage = "This user has already been setup as an API user for this profile."; 
                    }
                    return result;
                }
            }
        });
    }

    setValues(transactionType: string, profileId: string) {
        this.transactionType = transactionType;
        this.profileId = profileId;
    }

    beforeUserIdLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "E";
    }

    onUserIdLookupSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const modelRow = tableRow?.data as ModelRow;
            modelRow.set("profile_id", this.profileId);
            modelRow.set("transaction_type", this.transactionType);
            const textboxName = tableRow?.findComponentById("textboxName") as Textbox;
            if (textboxName) {
                textboxName.text = event.selection.get("name");
            }
        }

    }

    get transactionType(): string {
        return this._transactionType;
    }

    set transactionType(value: string) {
        this._transactionType = value;
    }

    get profileId(): string {
        return this._profileId;
    }

    set profileId(value: string) {
        this._profileId = value;
    }
}